import React from 'react'
import { Breadcrumbs } from '@/components/Breadcrumbs'

export type BreadcrumbsBlockProps = {
  items: Array<{
    label: string
    href?: string | null
    current?: boolean | null
  }>
  blockType: 'breadcrumbs'
}

export const BreadcrumbsBlock: React.FC<BreadcrumbsBlockProps> = ({ items }) => {
  const normalised = (items ?? []).map((i) => ({
    label: i.label,
    href: i.href ?? undefined,
    current: i.current ?? undefined,
  }))
  return <Breadcrumbs items={normalised} />
}
